export default {
  props: {
    resourceData: {
      required: true,
      type: Object
    },
    showLabel: {
      required: false,
      type: Boolean,
      default: false
    },
    labelContent: {
      required: false,
      type: String,
      default: "course_type_name"
    },
    cols: {
      required: false,
      type: String,
      default: "n + 3"
    },
    userInfo: {
      type: Object,
      default: null
    }
  }
};